import { render, staticRenderFns } from "./TrendingUp.vue?vue&type=template&id=793926f6&scoped=true"
import script from "./TrendingUp.vue?vue&type=script&lang=js"
export * from "./TrendingUp.vue?vue&type=script&lang=js"
import style0 from "./TrendingUp.vue?vue&type=style&index=0&id=793926f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793926f6",
  null
  
)

export default component.exports